import { Box, BoxProps, Text, TextProps } from '@chakra-ui/react';
import { ReactElement } from 'react';

type Props = {
  text: string;
  background?: BoxProps['backgroundColor'];
  color?: TextProps['color'];
  lineColor?: BoxProps['backgroundColor'];
};

export const Separator = ({ text, background, color, lineColor }: Props): ReactElement => {
  return (
    <Box position="relative" display="grid" placeContent="center" width="100%">
      <Box
        position="absolute"
        height="1px"
        width="100%"
        backgroundColor={lineColor || 'divider.default'}
        top="50%"
      />
      <Text
        as="span"
        px="l"
        backgroundColor={background || 'background.canvas'}
        position="relative"
        color={color || 'text.quaternary'}
      >
        {text}
      </Text>
    </Box>
  );
};
